<template>
  <div class='grid'>
    <a class='block' v-for="b in jlist" :href='b[2]' :key='b[1]' target="_blank">
      <div class='emo'>{{ b[0] }}</div>
      <div class='title'>{{ b[1] }}</div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jlist: [
        ['🤔', 'Персональный менеджмент', 'https://docs.google.com/spreadsheets/d/1LR18hErPgy38_-xaCs-UzGtevgd-LW57IQxSS4pAPTo/edit'],
        ['➕', 'Высшая математика', 'https://docs.google.com/spreadsheets/d/12JF3HR1nmxdGJDboC08vUDn7jSC2nLITMcN0VCQFtRI/edit'],
        ['👌', 'Информатика', 'https://docs.google.com/spreadsheets/d/1HS-_Xihmj8RnUzfFTJTuDFQuRUK0NlaJ2xDGQGVJRPA/edit'],
        ['🏓', 'Физкультура', 'https://docs.google.com/spreadsheets/d/1Ihp2HIug4UzpGzZpS3XM6c8M4VRB0h0ozBXrn7uelS4/edit'],
        ['🇺🇸', 'Иностранный язык', 'https://docs.google.com/spreadsheets/d/1-BJvJZP4rZqe3ZRapzqiaDIAbQ6QDM5IwmavdHT-loQ/edit'],
        ['🔗', 'Основы теории цепей', "https://docs.google.com/spreadsheets/d/1YM-TQzPuSIP6KVNWRPz8DncKGreFe8-Y2wiJG8ftruU/edit"],
        ['🔌', 'Физика', "https://docs.google.com/spreadsheets/d/12W0CFYXnpGYjLRtg4YgOYlxHK-rpY4KALqvtFYeP8jE/edit"],
        ['☎️', 'Основы телекоммуникаций', 'https://docs.google.com/spreadsheets/d/1vGmCWpJuEnvrBHm-0gQsgA8mXhjMo6351EHSEqyL7rc/edit'],
        ['🎧', 'Всеобщая история', 'https://docs.google.com/spreadsheets/d/1XnOI2f5n3gRm9TK4JVT6JVFdAQjR4KgRmjcosye6y_o/edit']
      ]
    }
  }
}
</script>

<style scoped>

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
  margin: 24px;
}

.block {
  display: block;
  color: var(--text);
  text-decoration: none;
  /* height: 72px; */
  background: var(--block-bg);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  font-weight: 600;
}

.title {
  font-size: 14px;
}

.emo {
  font-size: 20px;
  margin-bottom: 8px;
}

@media only screen and (max-width: 350px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

</style>